import classNames from "classnames";
import { TickSVG } from "@/components/svg";
import Text from "@/components/base/text";

const FeatureList = ({ className, features, isPremium = false }) => {
  return (
    <div className={className}>
      <div className="h-4">
        {isPremium && (
          <Text
            align="left"
            color="subheading"
            weight="semibold"
            className="ml-5 text-[8px]"
          >
            PREMIUM ADD-ONS
          </Text>
        )}
      </div>
      <ul
        role="list"
        className="my-1 space-y-2.5 text-xs text-left text-gray-600"
      >
        {features.map((feature) => (
          <li key={feature} className="flex gap-x-px items-center">
            <TickSVG
              className={classNames(
                "h-3 w-3 flex-none",
                isPremium ? "text-yellow" : "text-[#50BFA5]"
              )}
              aria-hidden="true"
            />
            {feature}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FeatureList;
